import { useMemo } from 'react'
import { useLocation } from 'react-router'

import { Loader } from '@paysense-india-services/elevate-web'

import { AuthContext } from '@/contexts/AuthContext'

import { useSessionAuth } from '@/hooks/useSessionAuth'

import { isAuthRoute } from '@/utils/authRoutes'

import SplitLayout from '@/components/SplitLayout'

export default function AuthLayout({ children }) {
  const { isAuthenticated, loading, isRedirecting, checkAuthSession, loginUser } = useSessionAuth()
  const { pathname } = useLocation()

  const authContextValue = useMemo(
    () => ({
      isUserLoggedIn: isAuthenticated,
      checkAuthSession,
      loginUser
    }),
    [isAuthenticated, checkAuthSession, loginUser]
  )

  if (loading || isRedirecting) {
    return <Loader color="brand" loadingText="Please Wait..." pageLoader size="large" />
  }

  return (
    <AuthContext.Provider value={authContextValue}>
      {isAuthRoute(pathname) ? <SplitLayout>{children}</SplitLayout> : children}
    </AuthContext.Provider>
  )
}
